import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  class: "fill-secondary",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.75 5a.7.7 0 0 1 .436.154L8.001 8.96l4.817-3.806a.7.7 0 0 1 .556-.143c.195.036.37.157.489.336a.9.9 0 0 1 .118.295.93.93 0 0 1-.094.626.8.8 0 0 1-.198.232L8 11 2.314 6.5a.8.8 0 0 1-.2-.233.928.928 0 0 1-.095-.63.9.9 0 0 1 .12-.296.8.8 0 0 1 .27-.254.7.7 0 0 1 .34-.087" }, null, -1)
  ])))
}
export default { render: render }